import { useState } from "react";

const faqs = [
  {
    q: "漫画网收录了哪些类型的漫画？",
    a: "漫画网收录漫画大全，涵盖热血、恋爱、悬疑、奇幻、科幻、搞笑六大类漫画网漫画分类，并配有完整的漫画网漫画库与漫画网漫画目录，方便你快速定位。",
  },
  {
    q: "如何在漫画网快速找到想看的漫画？",
    a: "你可以在首页进入漫画大全，通过顶部漫画网漫画分类切换不同题材，也可以按人气排行榜查看热门漫画。每部漫画都有清晰的章节目录，直接点进列表即可。",
  },
  {
    q: "漫画网上的漫画更新频率如何？",
    a: "漫画网持续收录并更新漫画内容，连载中的漫画会随着源站更新及时同步最新话，确保漫画网漫画目录保持最新。",
  },
  {
    q: "漫画网上的漫画可以免费阅读吗？",
    a: "漫画网致力于提供便捷的漫画阅读体验，收录的漫画均可直接进入列表在线阅读。所有内容版权归原作者所有，仅供阅读交流使用。",
  },
  {
    q: "可以投稿或推荐漫画给漫画网吗？",
    a: "当然可以！欢迎通过关于我们页面的联系方式向我们推荐优秀的漫画作品，我们会评估后收录进漫画网漫画库，让更多读者看到。",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="bg-background-50 py-12 md:py-16" aria-labelledby="faq-heading">
      <div className="container-x">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <i className="ri-question-line"></i> 常见问题
          </span>
          <h2 id="faq-heading" className="mt-3 font-display text-2xl font-black text-foreground-900 md:text-3xl">
            你可能想知道的
          </h2>
        </div>

        <div className="mx-auto mt-8 max-w-3xl divide-y divide-background-200/70 rounded-lg border border-background-200/70 bg-background-50">
          {faqs.map((f, idx) => {
            const active = open === idx;
            return (
              <div key={f.q}>
                <button
                  type="button"
                  onClick={() => setOpen(active ? -1 : idx)}
                  aria-expanded={active}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="text-sm font-semibold text-foreground-900 md:text-base">{f.q}</h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      active ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                    }`}
                  >
                    <i className={`ri-add-line text-sm transition-transform ${active ? "rotate-45" : ""}`}></i>
                  </span>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${active ? "max-h-40" : "max-h-0"}`}>
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}